import { render } from "./saleslistmodal.vue?vue&type=template&id=5d53251e"
import script from "./saleslistmodal.vue?vue&type=script&lang=js"
export * from "./saleslistmodal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/arthaskyline/Documents/FILE_DELFIN/kodingan-arthaskyline/level-up/levelup-github/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__